import * as React from 'react'

import type { ENTITY_TYPES } from '@sales-center/common'
import { AppointmentMenu } from './AppointmentMenu'
import { Layout, RequirementsDataGrid } from '../atoms'
import { useData, useHandlers, useColumns } from './hooks'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

type Props = {
  entityId: number
  entityClosed: boolean
  entityType: ENTITY_TYPES
  canUpdate: boolean
}

export function AppointmentsTable(props: Props) {
  const { entityId, entityClosed, entityType, canUpdate } = props

  const { row, loading, anchorEl, setMenuState, appointments } = useData(props)
  const { formatDate } = useLocalizationDateFormat()

  const { rowMenuClick, onCloseRowMenu } = useHandlers({
    setMenuState,
  })

  const columns = useColumns({ rowMenuClick })

  const localizedColumns = columns?.map((row) => {
    if (row.type == 'date' || row.type == 'dateTime') {
      return {
        ...row,
        valueFormatter: (params) => formatDate(params.value, row.type),
      }
    }
    return row
  })

  return (
    <>
      <Layout
        title="Appointment History"
        count={appointments.length}
        dataTestId="requirementsDataGrid"
        table={
          <RequirementsDataGrid
            autoHeight
            hideFooter
            columns={localizedColumns}
            loading={loading}
            disableColumnMenu
            rows={appointments}
            disableRowSelectionOnClick
            getRowId={(r) => r.appointmentId}
          />
        }
      />

      <AppointmentMenu
        row={row}
        anchorEl={anchorEl}
        entityId={entityId}
        entityType={entityType}
        onClose={onCloseRowMenu}
        entityClosed={entityClosed}
        canUpdate={canUpdate}
      />
    </>
  )
}
